export default {
  sections: {
    alcohol_percentage: 'Teor de álcool: {{value}}%',
    price_per_unit: 'Preço por {{unit}}: {{value}}',
    gtin: 'GTIN',
    ingredients: 'Ingredientes',
    allergens: 'Alergénios',
    additives: 'Aditivos',
    nutrition_breakdown: {
      title: 'Informação nutricional',
      description: '100 {{unit}} contém:',
      items: {
        energy: 'Energia',
        fat: 'Gordura',
        saturates: 'dos quais ácidos gordos saturados',
        carbohydrates: 'Hidratos de carbono',
        sugars: 'dos quais açúcares',
        protein: 'Proteínas',
        salt: 'Sal',
      },
    },
  },
  units: {
    l: 'litro',
    kg: 'quilo',
    default: 'unidade',
  },
};
